import { useMutation, useQueryClient } from 'react-query';
import { QUERY_KEYS } from 'api/query-keys';
import { sharedCompanyService } from 'api/services';
import { UpdateContractorCompanyRate } from 'api/services/company/company-service.schema';

export const useUpdateContractorCompanyRates = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payloads: UpdateContractorCompanyRate[]) => {
      for (const payload of payloads) {
        await sharedCompanyService.updateContractorCompanyRate(payload);
      }
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEYS.companies());
      },
    }
  );
};
